<script setup lang="ts">
import { twMerge } from "tailwind-merge"

const props = defineProps<{ class?: string }>()
</script>
<template>
  <p :class="twMerge('text-sm leading-5 text-zinc-500', props.class)">
    <slot />
  </p>
</template>
